import { Button, Typography } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import serviceFaturaSaldoChurn from "../../../../services/serviceFaturaSaldoChurn";
import { toast } from "react-toastify";
import { useState } from "react";
import { Loader } from "./styles";
export interface IDialogProps {
    open: boolean;
    onClose?: any;
    idProp?: any;
    clearDataTable: () => void;
}

export default function DialogApproveById({ open, onClose, idProp, clearDataTable }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const handleRequest = async () => {
        setDisable(true);

        serviceFaturaSaldoChurn
            .approve(idProp.id)
            .then((result) => {
                if (result) {
                    toast.success("Cobrança aprovada com sucesso!");
                    onClose();
                    clearDataTable();
                }
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Aprovar Cobrança
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid item xs={12}>
                        {isDisable && (
                            <Loader>
                                <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                            </Loader>
                        )}
                    </Grid>
                    <Typography>
                        {idProp &&
                            idProp?.numeroInstalacao &&
                            `Tem certeza que deseja aprovar a cobrança para a Instalação ${idProp.numeroInstalacao}?`}
                    </Typography>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    {idProp && (
                        <Button
                            onClick={() => handleRequest()}
                            variant="contained"
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Confirmar
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
}
